import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Smartphone, Brain, Wallet, Database, Shield, Zap, CheckCircle2 } from 'lucide-react';
import SiteNav from '../../components/site/SiteNav';
import SiteFooter from '../../components/site/SiteFooter';

const WhyUgra = () => {
    const reasons = [
        {
            title: 'Uygulama İndirmeye Son',
            subtitle: 'Sürtünmesiz Müşteri Deneyimi',
            desc: 'Müşterileriniz uygulama indirmek zorunda değil. QR kod okutarak tarayıcıdan check-in yapıyor, puanlarını görüyor, ödüllerini kullanıyor ve sipariş veriyor. Araştırmalar, işletme başına ayrı uygulama indirme taleplerinin müşterilerin %70\'ini kaybettiğini gösteriyor.',
            icon: Smartphone,
            color: '#ec4899',
            tags: ['Web Tabanlı', 'QR Check-in', 'Sıfır Kurulum']
        },
        {
            title: 'AI Destekli İş Ortağı',
            subtitle: 'Gemini 2.5 Flash Gücü',
            desc: 'Yapay zeka danışmanınız menü optimizasyonu yapar, stok analizi önerir, kampanya fikirleri üretir ve müşteri davranışlarını yorumlar. İşletmenizin verilerini anlayan kişiselleştirilmiş bir dijital iş ortağı.',
            icon: Brain,
            color: '#8b5cf6',
            tags: ['AI Danışman', 'Menü Mühendisliği', 'Premium']
        },
        {
            title: 'Şeffaf Maliyet',
            subtitle: 'Kurulum Ücreti Yok',
            desc: 'Gizli ücret, komisyon veya kurulum bedeli yok. Ücretsiz başlayın, büyüdükçe Pro veya Premium plana geçin. Aylık 990 ₺\'den başlayan fiyatlarla tüm CRM özelliklerine erişin.',
            icon: Wallet,
            color: '#10b981',
            tags: ['Ücretsiz Başlangıç', '990 ₺/ay', 'Komisyonsuz']
        },
        {
            title: 'Veri Mülkiyeti',
            subtitle: 'Müşteriniz Sizin Kalsın',
            desc: 'Üçüncü parti platformlara komisyon ödemeyin. Müşteri verileriniz tamamen size ait. Multi-tenant mimarimizle her işletmenin verileri izole ve güvende.',
            icon: Database,
            color: '#0ea5e9',
            tags: ['Veri Güvenliği', 'KVKK Uyumlu', 'Multi-tenant']
        },
        {
            title: 'Modern Teknoloji Altyapısı',
            subtitle: 'React 19 + Supabase + Vercel',
            desc: 'Sunucusuz mimari ile sınırsız ölçeklenebilirlik. Real-time veri senkronizasyonu, Redis önbellekleme ve CDN dağıtımı. Her cihazdan erişilebilir, her an güncel.',
            icon: Shield,
            color: '#6366f1',
            tags: ['Serverless', 'Real-time', '%99.9 Uptime']
        }
    ];

    const comparisons = [
        { feature: 'Uygulama indirme gereksinimi', ugra: 'Hayır', others: 'Evet' },
        { feature: 'Ücretsiz plan', ugra: 'Var', others: 'Genellikle yok' },
        { feature: 'Müşteri verisi mülkiyeti', ugra: 'İşletmeye ait', others: 'Platforma ait' },
        { feature: 'AI danışman', ugra: 'Var (Premium)', others: 'Yok' },
        { feature: 'QR menü + sadakat + sipariş', ugra: 'Tek platform', others: 'Ayrı uygulamalar' },
        { feature: 'Komisyon', ugra: '0%', others: '%2-15' },
    ];

    return (
        <div className="whyugra-page" style={{ background: 'var(--bg-main)', color: 'var(--text-main)', minHeight: '100vh', overflowX: 'hidden' }}>
            <SiteNav />
            <style>{`
                .reason-card { background: var(--bg-card); border: 1px solid var(--border); border-radius: 24px; padding: 2.5rem; transition: all 0.3s; }
                .reason-card:hover { transform: translateY(-4px); border-color: var(--primary); box-shadow: 0 20px 40px -10px rgba(var(--primary-rgb), 0.1); }
                .tag { display: inline-flex; padding: 4px 12px; border-radius: 8px; font-size: 0.7rem; font-weight: 700; background: var(--bg-main); color: var(--text-muted); border: 1px solid var(--border); }
                .compare-table { width: 100%; border-collapse: separate; border-spacing: 0; }
                .compare-table th, .compare-table td { padding: 1rem 1.5rem; text-align: left; border-bottom: 1px solid var(--border); }
                .compare-table th { font-size: 0.75rem; font-weight: 800; text-transform: uppercase; color: var(--text-muted); letter-spacing: 0.05em; }
                .compare-table tr:last-child td { border-bottom: none; }
                @media (max-width: 768px) { .whyugra-page section { padding-left: 5% !important; padding-right: 5% !important; } .reasons-row { grid-template-columns: 1fr !important; max-width: 100% !important; } .reason-card { padding: 1.75rem !important; } .compare-desktop { display: none !important; } .compare-mobile { display: flex !important; } }
            `}</style>

            <section style={{ padding: '14rem 10% 4rem', textAlign: 'center' }}>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(var(--primary-rgb), 0.1)', color: 'var(--primary)', padding: '8px 16px', borderRadius: 99, fontSize: '0.8125rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: '1.5rem' }}>
                    <Zap size={14} /> Neden ugra?
                </div>
                <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)', fontWeight: 900, letterSpacing: '-0.03em', marginBottom: '1rem' }}>Farkı Hissedin</h1>
                <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem', maxWidth: 600, margin: '0 auto' }}>ugra'yı diğer çözümlerden ayıran 5 temel özellik.</p>
            </section>

            <section style={{ padding: '0 10% 6rem' }}>
                {/* Row 1: 3 cards */}
                <div className="reasons-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.25rem', maxWidth: 1100, margin: '0 auto 1.25rem' }}>
                    {reasons.slice(0, 3).map((r, i) => (
                        <div key={i} className="reason-card" style={{ textAlign: 'center' }}>
                            <div style={{ width: 56, height: 56, borderRadius: 16, background: `${r.color}12`, color: r.color, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.25rem' }}>
                                <r.icon size={26} />
                            </div>
                            <div style={{ fontSize: '0.7rem', fontWeight: 700, color: r.color, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: '0.35rem' }}>{r.subtitle}</div>
                            <h3 style={{ fontSize: '1.15rem', fontWeight: 800, marginBottom: '0.75rem' }}>{r.title}</h3>
                            <p style={{ color: 'var(--text-muted)', lineHeight: 1.7, fontSize: '0.85rem', marginBottom: '1.25rem' }}>{r.desc}</p>
                            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', justifyContent: 'center' }}>
                                {r.tags.map((tag, j) => <span key={j} className="tag">{tag}</span>)}
                            </div>
                        </div>
                    ))}
                </div>
                {/* Row 2: 2 cards centered */}
                <div className="reasons-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1.25rem', maxWidth: 730, margin: '0 auto' }}>
                    {reasons.slice(3).map((r, i) => (
                        <div key={i} className="reason-card" style={{ textAlign: 'center' }}>
                            <div style={{ width: 56, height: 56, borderRadius: 16, background: `${r.color}12`, color: r.color, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.25rem' }}>
                                <r.icon size={26} />
                            </div>
                            <div style={{ fontSize: '0.7rem', fontWeight: 700, color: r.color, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: '0.35rem' }}>{r.subtitle}</div>
                            <h3 style={{ fontSize: '1.15rem', fontWeight: 800, marginBottom: '0.75rem' }}>{r.title}</h3>
                            <p style={{ color: 'var(--text-muted)', lineHeight: 1.7, fontSize: '0.85rem', marginBottom: '1.25rem' }}>{r.desc}</p>
                            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', justifyContent: 'center' }}>
                                {r.tags.map((tag, j) => <span key={j} className="tag">{tag}</span>)}
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section style={{ padding: '6rem 10%', background: 'rgba(var(--primary-rgb), 0.02)' }}>
                <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
                    <h2 style={{ fontSize: '2rem', fontWeight: 900, marginBottom: '0.5rem' }}>ugra vs. Diğerleri</h2>
                    <p style={{ color: 'var(--text-muted)' }}>Hızlı karşılaştırma</p>
                </div>
                {/* Desktop: table / Mobile: cards */}
                <div className="compare-desktop" style={{ maxWidth: 700, margin: '0 auto' }}>
                    <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 20, overflow: 'hidden' }}>
                        <table className="compare-table">
                            <thead>
                                <tr style={{ background: 'var(--bg-main)' }}>
                                    <th>Özellik</th>
                                    <th style={{ color: 'var(--primary)' }}>ugra</th>
                                    <th>Diğerleri</th>
                                </tr>
                            </thead>
                            <tbody>
                                {comparisons.map((c, i) => (
                                    <tr key={i}>
                                        <td style={{ fontWeight: 600, fontSize: '0.875rem' }}>{c.feature}</td>
                                        <td style={{ color: '#10b981', fontWeight: 700, fontSize: '0.875rem' }}>
                                            <CheckCircle2 size={14} style={{ verticalAlign: 'middle', marginRight: 6 }} />{c.ugra}
                                        </td>
                                        <td style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>{c.others}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="compare-mobile" style={{ display: 'none', flexDirection: 'column', gap: '0.75rem' }}>
                    {comparisons.map((c, i) => (
                        <div key={i} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, padding: '1rem 1.25rem' }}>
                            <div style={{ fontWeight: 700, fontSize: '0.9rem', marginBottom: '0.75rem' }}>{c.feature}</div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                                <div>
                                    <div style={{ fontSize: '0.65rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', marginBottom: '0.2rem' }}>ugra</div>
                                    <div style={{ color: '#10b981', fontWeight: 700, fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: 4 }}>
                                        <CheckCircle2 size={14} /> {c.ugra}
                                    </div>
                                </div>
                                <div style={{ textAlign: 'right' }}>
                                    <div style={{ fontSize: '0.65rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', marginBottom: '0.2rem' }}>Diğerleri</div>
                                    <div style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>{c.others}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section style={{ padding: '6rem 10%', textAlign: 'center' }}>
                <div style={{ background: 'var(--primary)', color: 'white', padding: '4rem 2rem', borderRadius: 28, maxWidth: 700, margin: '0 auto' }}>
                    <h2 style={{ fontSize: '2rem', fontWeight: 900, marginBottom: '1rem' }}>Denemeye Başlayın</h2>
                    <p style={{ opacity: 0.9, marginBottom: '2rem', maxWidth: 400, margin: '0 auto 2rem' }}>Ücretsiz plan ile QR menünüzü hemen oluşturun. Kredi kartı gerekmez.</p>
                    <Link to="/signup" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'white', color: 'var(--primary)', padding: '1rem 2.5rem', borderRadius: 14, fontWeight: 800, textDecoration: 'none' }}>
                        Ücretsiz Başla <ArrowRight size={18} />
                    </Link>
                </div>
            </section>

            <SiteFooter />
        </div>
    );
};

export default WhyUgra;
